/* OCAAT sample-set (v3, 2026-08).
   One script, three jobs:
   1. Keeps every on-page [data-sample-nudge] progress box in sync with the cart.
   2. Injects the interactive "complete your set" module into the cart drawer:
      nudge message, progress dots, and one-tap ADD buttons for the other
      samples, on every page (config comes from snippets/sample-cart.liquid).
   3. Quantity steppers on the sample PDP hero.
   The drawer body is rebuilt by assets/cart.js after every cart change, so a
   MutationObserver re-injects the module (the old v2 wrapped
   window.OCAATCart.refresh, which cart.js never calls internally: bug).
   Self-guards against double-load (theme.liquid include + section includes). */
(function () {
  'use strict';
  if (window.__OCAATSampleSet) { return; }
  window.__OCAATSampleSet = true;

  function config() {
    var el = document.querySelector('[data-sample-config]');
    if (!el) { return null; }
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function sampleIds(cfg) {
    var set = {};
    if (cfg) { cfg.samples.forEach(function (s) { set[s.id] = true; }); }
    var nodes = document.querySelectorAll('[data-sample-ids]');
    Array.prototype.forEach.call(nodes, function (el) {
      try { JSON.parse(el.textContent).forEach(function (id) { set[id] = true; }); }
      catch (e) { /* skip malformed */ }
    });
    return set;
  }

  function msgFor(n, get) {
    if (n >= 3) { return get('done'); }
    if (n === 2) { return get('msg2'); }
    if (n === 1) { return get('msg1'); }
    return get('msg0');
  }

  function paintDots(scope, n) {
    var dots = scope.querySelectorAll('i');
    Array.prototype.forEach.call(dots, function (dot, i) {
      dot.classList.toggle('is-filled', i < Math.min(n, 3));
    });
  }

  /* ---- on-page nudge boxes (sample PDP + grids) ---- */
  function paintPageNudges(n) {
    var nudges = document.querySelectorAll('[data-sample-nudge]');
    Array.prototype.forEach.call(nudges, function (el) {
      var msg = msgFor(n, function (k) {
        return el.getAttribute('data-msg-' + (k === 'done' ? 'done' : k.replace('msg', '')));
      });
      var text = el.querySelector('[data-sample-text]');
      if (text && msg) { text.textContent = msg; }
      el.classList.toggle('is-complete', n >= 3);
      var dots = el.querySelector('[data-sample-dots]');
      if (dots) { paintDots(dots, n); }
    });
  }

  /* ---- the in-drawer module ---- */
  function paintDrawer(n, cfg) {
    var body = document.querySelector('[data-cart-drawer-body]');
    if (!body || !cfg) { return; }
    var host = body.querySelector('[data-sample-drawer]');
    if (n < 1) { if (host) { host.parentNode.removeChild(host); } return; }
    if (host && host.getAttribute('data-n') === String(n)) { return; }
    if (!host) {
      host = document.createElement('div');
      host.setAttribute('data-sample-drawer', '');
      var footer = body.querySelector('.cart-drawer__footer');
      body.insertBefore(host, footer || null);
    }
    host.setAttribute('data-n', String(n));
    var rows = cfg.samples.map(function (s) {
      return '<li class="sdw__item">' +
        '<a href="' + s.url + '" tabindex="-1">' +
          (s.image ? '<img src="' + s.image + '" alt="" width="40" height="52" loading="lazy">' : '') +
        '</a>' +
        '<span class="sdw__item-name">' + s.title.replace(' 2cl Sample', '') + '</span>' +
        '<button type="button" class="sdw__item-add" data-sample-quick-add="' + s.variantId + '">+ ' + s.price + '</button>' +
      '</li>';
    }).join('');
    host.innerHTML =
      '<div class="sdw__nudge' + (n >= 3 ? ' is-complete' : '') + '">' +
        '<span class="sdw__dots" aria-hidden="true"><i></i><i></i><i></i></span>' +
        '<span>' + msgFor(n, function (k) { return cfg.strings[k]; }) + '</span>' +
      '</div>' +
      '<ul class="sdw__list">' + rows + '</ul>';
    paintDots(host.querySelector('.sdw__dots'), n);
  }

  var painting = false;
  function update() {
    var cfg = config();
    var ids = sampleIds(cfg);
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) { throw new Error('cart ' + r.status); } return r.json(); })
      .then(function (cart) {
        var n = (cart.items || []).reduce(function (sum, item) {
          return ids[item.product_id] ? sum + item.quantity : sum;
        }, 0);
        painting = true;
        paintPageNudges(n);
        paintDrawer(n, cfg);
        painting = false;
      })
      .catch(function () { /* leave server-rendered state */ });
  }

  /* re-run whenever cart.js rebuilds the drawer body */
  var debounce = null;
  function watchDrawer() {
    var body = document.querySelector('[data-cart-drawer-body]');
    if (!body || !window.MutationObserver) { return; }
    new MutationObserver(function () {
      if (painting) { return; }
      clearTimeout(debounce);
      debounce = setTimeout(update, 120);
    }).observe(body, { childList: true, subtree: true });
  }

  /* quick add from the drawer module */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sample-quick-add]');
    if (btn) {
      if (btn.disabled) { return; }
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: parseInt(btn.getAttribute('data-sample-quick-add'), 10), quantity: 1 })
      })
        .then(function () {
          if (window.OCAATCart && window.OCAATCart.refresh) { return window.OCAATCart.refresh(); }
        })
        .then(update)
        .catch(function () { /* leave cart as-is */ })
        .then(function () { btn.disabled = false; });
      return;
    }
    var step = e.target.closest('[data-sample-step]');
    if (step) {
      var wrap = step.closest('[data-sample-qty]');
      var input = wrap && wrap.querySelector('input[name="quantity"]');
      if (!input) { return; }
      var next = (parseInt(input.value, 10) || 1) + parseInt(step.getAttribute('data-sample-step'), 10);
      input.value = Math.max(1, next);
    }
  });

  function init() { watchDrawer(); update(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
